module.exports = __webpack_public_path__ + "static/img/m_global_flow_step4@3x.b99b77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_flow_step4@3x.png
// module id = bb4t
// module chunks = 1